import { ReactNode } from "react";

function IconWrapper(props: {
  children?: ReactNode;
  onClick?: () => void;
  size?: number;
  className?: string;
}) {
  return (
    <div
      className={`grid place-items-center bg-white hover:bg-gray-100 active:bg-gray-100 duration-200 rounded-[6px] text-gray-400 cursor-pointer ${props.className}`}
      onClick={props.onClick}
      style={{ width: props.size || 24, height: props.size || 24 }}
    >
      {props.children}
    </div>
  );
}

export const Wrapper = {
  Icon: IconWrapper,
};
